export interface PlayerScoreCard {
  readonly userId: string
  readonly leftPlayerWhistPoints: number[]
  readonly poolPoints: number[]
  readonly rightPlayerWhistPoints: number[]
}

export const playerScoreCardNull: PlayerScoreCard = {
  userId: '',
  leftPlayerWhistPoints: [],
  poolPoints: [],
  rightPlayerWhistPoints: [],
}
